export default __webpack_public_path__ + "static/media/level-8.89c60420.png";